if (!window.Eurus.loadedScript.has('cart-digital-consent.js')) {
  window.Eurus.loadedScript.add('cart-digital-consent.js');

  const registerCartDigitalConsent = () => {
    Alpine.store('xDigitalConsent', {
      checked: false
    });

    Alpine.data('xCartDigitalConsent', () => ({
      error: false,
      _saveTimer: null,
      init() {
        this.error = false;

        // Shared store keeps drawer + cart page instances in sync.
        this.$watch('$store.xDigitalConsent.checked', () => {
          this.error = false;
          this.$el.classList.remove('digital-consent--flash');
          this.queueSave();
        });

        // Always start unchecked after (re)mount — do not restore prior consent (legal compliance).
        Alpine.store('xDigitalConsent').checked = false;

        this._onValidate = () => {
          // Ignore listeners left behind after cart AJAX re-renders replaced this node.
          if (!this.$el.isConnected) return;

          if (!Alpine.store('xDigitalConsent').checked) {
            this.error = true;
            Alpine.store('xCartHelper').validated = false;
            this.$el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            this.$el.classList.remove('digital-consent--flash');
            void this.$el.offsetWidth; // reflow to restart animation
            this.$el.classList.add('digital-consent--flash');
          } else {
            this.error = false;
            this.$el.classList.remove('digital-consent--flash');
          }
        };

        document.addEventListener('eurus:cart:validate', this._onValidate);
      },
      destroy() {
        document.removeEventListener('eurus:cart:validate', this._onValidate);
        clearTimeout(this._saveTimer);
      },
      queueSave() {
        clearTimeout(this._saveTimer);

        this._saveTimer = setTimeout(() => {
          // One POST only when several consent UIs are mounted (drawer + cart page).
          const root = document.querySelector('.js-digital-consent');
          if (root !== this.$el) return;

          Alpine.store('xCartHelper').updateCart({
            attributes: {
              'Accord contenu numerique': Alpine.store('xDigitalConsent').checked ? 'accepte' : ''
            }
          });
        }, 200);
      }
    }));
  };

  if (window.Alpine) {
    registerCartDigitalConsent();
  } else {
    document.addEventListener('alpine:init', registerCartDigitalConsent);
  }
}
